import React from "react";
import { sanitize } from "dompurify";

const NotesBar = ({ instructions = [] }) => {
  return (
    <div
      className="information-snippet"
      style={{
        padding: "1rem",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        marginBottom: "1rem",
      }}
    >
      {instructions.length > 0 && (
        <React.Fragment>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.5",
              fontWeight: "400",
              color: "#ff5a5f",
            }}
          >
            Note:
          </p>
          <ul>
            {instructions.map((instruction) => (
              <li
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.5",
                  fontWeight: "400",
                }}
                dangerouslySetInnerHTML={{ __html: sanitize(instruction) }}
              />
            ))}
          </ul>
        </React.Fragment>
      )}
    </div>
  );
};

export default React.memo(NotesBar);
